import { Document } from '../commons';

export interface PicturesViewerData {
  pictures: Document[];
  index: number;
  allowUnsupported?: boolean;
}
